module.exports = __webpack_public_path__ + "img/voting-template-1.26f745fb.png";